$(function() {
    cartDrawerUpdate();
    initFeaturedCollectionSlider();
    initMobileNavSlider();
    checkUrlForFilter();
    onLoadUpdateCharacterCount();
    onLoadCheckNewsletterTrigger();
    drawerUpsellGridHeight();
    setMobilePromoGridHeight();
    onloadToggleDonation();
    dynamicHeightSideNav();
    onLoadCheckAnnouncementBar();
    initYmalSlider();
    mobileAccountOrderColSpan();
    updateStoreSelectorText();
    removeIncompleteBundleSet();
    gwpMinCartQty();
    colPurchaseGwp();
    minSpendGwp();
    tierGwp();
    removePastGwp();
    setMegamenuWidth();
    // Start: FAQ page
    dynamicSideNavTop();
    // End: FAQ page

    document.addEventListener('on:cart:after-merge', (event) => {
        setTimeout(function() { 
            gwpMinCartQty();
            colPurchaseGwp();
            minSpendGwp();
            tierGwp();
        }, 500); // Note: Added setTimeout bcos when click remove btn it doesn't trigger immediately."
      });
      
      document.addEventListener('on:cart-drawer:after-close', (event) => {
        // show chat widget
        $('#gorgias-chat-container').show();
        $('#bon-loyalty-btn').css('opacity', '1');
    });
});

// Start: gwp min cart qty
gwpMinCartQty = () => {
    var $gwp_min_cart_qty = $('.jsc-gwp-min-cart-qty');
    $gwp_min_cart_qty.each(function(index, $gwpEl) {
        var newIndex = index + 1;
        var $accumulate_qty = 0;
        var $purchase_qty = parseInt($($gwpEl).attr('purchaseQty'));
        var $gift_inventory = parseInt($($gwpEl).attr('gift-inventory'));

        if ($gift_inventory > 0){
            $(`.jsc-cart-item-qtycol-${newIndex}`).each(function() {
                var $item_qty = parseInt($(this).find('.cart-item__not-image').find('.cart-item__quantity .quantity .cart-item__quantity-input').attr('data-initial-value'));
                
                if (!isNaN($item_qty)) {
                    $accumulate_qty += $item_qty;
                }
            });

            var $gift_qty = Math.floor($accumulate_qty / $purchase_qty);

            if ($gift_qty > $gift_inventory){
                $gift_qty = $gift_inventory;
            }
            
            var $giftHandle = $($gwpEl).attr('gift-handle');
            var $giftVid = $($gwpEl).attr('gift-vid');

            var $isGiftInCart = false; 
            var $isUpdate = false;
            var $isDelete = true;

            var $gift_key = '';
            var $isGiftInCartQty = 0;
            var $obj = {};
            
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                
                cart.items.forEach(item => {
                    var $productHandle = item.handle; 
                    var $productProps = item.properties;
                    if (($productHandle == $giftHandle) && ($productProps['_Promo'] == 'Free Gift')){
                        $isGiftInCart = true; 
                        $isGiftInCartQty = item.quantity; 

                        if ($gift_qty != item.quantity){
                            $gift_key = item.key;
                            $isUpdate = true;
                        }
                    }
            
                });

                if (($isGiftInCart) && ($isUpdate)){
                    cartJsUpdate($gift_key,$gift_qty,{});
                    console.log('update',$gift_qty);
                }

                if (($isGiftInCart == false) && ($gift_qty > 0)){
                    $obj['_Promo'] = 'Free Gift';
                    cartJsAtc($giftVid,$gift_qty,$obj);
                }
        
                if ($accumulate_qty >= $gift_qty){
                    $isDelete = false;
                }

                if (($isGiftInCart) && ($isDelete)){
                    cartJsUpdate($gift_key,0);
                    console.log('remove',$gift_qty);
                }

            })
            .catch(error => console.error('Error fetching cart:', error));
        }
    });
}
// End: gwp min cart qty

// Start: col purchase gwp
colPurchaseGwp = () => {
    var $gwp_inventory = parseInt($('.jsc-col-purchase-gwp').attr('gwp-inventory'));
    var $gwp_vid = $('.jsc-col-purchase-gwp').attr('gwp-vid');
    
    var $obj = {};
    var $gwpItemCount = 0;
    var $gwp_key = null;
    var $isGiftInCart = false; 

    if ($gwp_inventory > 0) {

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            
            cart.items.forEach(item => {
                var $productProps = item.properties;

                if ($productProps['_ColPurchaseGwp'] == 'Free Gift') {
                    $isGiftInCart = true;
                    $gwp_key = item.key;  
                    $gwpItemCount = item.quantity;  
                }
            });

            if (!$isGiftInCart && $('.jsc-cart-item-colPurchase').length > 0) {
                $obj['_ColPurchaseGwp'] = 'Free Gift';
                cartJsAtc($gwp_vid, 1, $obj); 
            }

            if ($isGiftInCart) {
                if ($gwpItemCount > 1) {
                    cartJsUpdate($gwp_key, 1, {});  ;
                }
            }

            if ($('.jsc-cart-item-colPurchase').length === 0 && $isGiftInCart) {
                cartJsUpdate($gwp_key, 0, {});
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }
}


// End: col purchase gwp

// Start: Min spend gwp
minSpendGwp = () =>{
    var $gwp_inventory = parseInt($('.jsc-min-spend-gwp').attr('gwp-inventory'));
    var $gwp_vid = $('.jsc-min-spend-gwp').attr('gwp-vid');
    var $min_spend = parseInt($('.jsc-min-spend-gwp').attr('min-spend'));
    var $applied_each = $('.jsc-min-spend-gwp').attr('gwp-applied-each');
    console.log('$applied_each: ', $applied_each);
    
    var $isGiftInCart = false;
    var $gwp_key = null;
    var $isGiftInCartQty = 0;

    if ($gwp_inventory > 0) {

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {

            var $finalTotal = 0;

            // Calculate the total price of included items
            $('.jsc-cart-item-minSpendCol').each(function() {
                var $itemOriginalPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
                var $itemQuantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));

                $itemOriginalPrice =  $itemOriginalPrice * $itemQuantity;
                $finalTotal += $itemOriginalPrice;
            });

            cart.items.forEach(item => {
                var $productProps = item.properties;

                if ($productProps['_MinSpendGwp'] === 'Free Gift') {
                    $isGiftInCart = true;
                    $gwp_key = item.key;
                    $isGiftInCartQty = item.quantity; 
                }
            });

            var $gift_qty = 1;
            if ($applied_each === 'true' || $applied_each === true && $finalTotal >= $min_spend) {
                $gift_qty = Math.floor($finalTotal / $min_spend);
                if ($gift_qty > $gwp_inventory){
                    $gift_qty = $gwp_inventory;
                }
            }
            console.log($finalTotal,'$finalTotal',$min_spend, $isGiftInCart, $gift_qty)

            if($finalTotal >= $min_spend && $isGiftInCart == false) { // adding GWP
                cartJsAtc($gwp_vid, $gift_qty, {'_MinSpendGwp': 'Free Gift'});
            }
            else if($finalTotal < $min_spend && $isGiftInCart) { // removing GWP
                cartJsUpdate($gwp_key, 0, {});
            }
            else if($finalTotal >= $min_spend && $isGiftInCart) { // update GWP qty to 1
                if($isGiftInCartQty != $gift_qty) {
                  console.log('updatingGWP: ', $gift_qty);
                  cartJsUpdate($gwp_key, $gift_qty, {'_MinSpendGwp': 'Free Gift'});
                }
            }

        })
        .catch(error => console.error('Error fetching cart:', error));
    }

}
// End: Min spend gwp

// Start: Tier GWP
tierGwp = () => {
    var $tierGwp = $('.jsc-tier-gwp');
    if ($tierGwp.length > 0) {
        var eligibleCartTotal = 0;
        var gwpInfo = {};

        $('.jsc-cart-item-tier-col').each(function() {
            var unitPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
            var quantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));

            var totalPrice = unitPrice * quantity;
            eligibleCartTotal += totalPrice;
        });

        $tierGwp.each(function() {
            var gwpInventory = parseInt($(this).attr('gwp-inventory'));
            var minSpend = parseInt($(this).attr('min-spend'));
            var gwpId = parseInt($(this).attr('gwp-vid'));

            if (gwpInventory > 0) {
                if (eligibleCartTotal >= minSpend) {
                    gwpInfo[gwpId] = (gwpInfo[gwpId] || 0) + 1;
                }
            }
        });

        $tierGwp.each(function() {
            var gwpId = parseInt($(this).attr('gwp-vid'));
            var gwpInventory = parseInt($(this).attr('gwp-inventory'));
            var isGwpInCart = false;
            var inCartQty = 0;
            var minSpend = parseInt($(this).attr('min-spend'));
            var key = null;

            if (gwpInventory > 0) {
                fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    cart.items.forEach(item => {
                        var itemProps = item.properties;
                        if (itemProps['_TierGwp'] == 'Free Gift' && item.id == gwpId) {
                            isGwpInCart = true;
                            inCartQty = item.quantity;
                            key = item.key;
                        }
                    });

                    if(isGwpInCart == false && gwpId in gwpInfo && eligibleCartTotal >= minSpend) {
                        cartJsAtc(gwpId, gwpInfo[gwpId], {'_TierGwp': 'Free Gift'});
                    }
                    else if (isGwpInCart == true && !(gwpId in gwpInfo)) {
                        cartJsUpdate(key, 0, {});
                    }
                    else if(isGwpInCart == true && gwpId in gwpInfo && inCartQty != gwpInfo[gwpId]) {
                        cartJsUpdate(key, gwpInfo[gwpId], {'_TierGwp': 'Free Gift'});
                    }
                });
            }
        });
    }
}
// End: Tier GWP

// Start: remove past GWP
removePastGwp = () => {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        cart.items.forEach(item => {
            var key = item.key;
            var id = item.id;
            var properties = item.properties;

            if(properties['_Promo'] != undefined || properties['_ColPurchaseGwp'] != undefined || properties['_MinSpendGwp'] != undefined || properties['_TierGwp'] != undefined) {
                var $gwpInfo = $('input[name="gwp-info"][gwp-vid="' + id + '"]');
                if($gwpInfo.length == 0) {
                    cartJsUpdate(key, 0, {});
                }
            }
        });
    });
}
// End: remove past GWP

// Start: personalisation
bindRemove = (evt) => {
    var $this = $(evt);
    var $actionVal = 'remove-';
    removeBindClick($this,$actionVal);
}

removeBindClick = (e, actionVal) => {
    var $bindId = e.attr('data-bindId');
    $('.' + actionVal + $bindId).each(function() {
        this.click();
    });
    
    setTimeout(function() {
        $.getJSON('/cart.js', function(cart) {
            var $count = cart.item_count;
            $('.cart-link__count').text($count);
            $('.jsc-drawer-item-count .jsc-item-count').text($count);
        });
    }, 500);
}

bindPlusQty = (evt) => {
    var $this = $(evt);
    var $actionVal = 'plus-';
    plusMinusBindClick($this,$actionVal);
}

bindMinusQty = (evt) => {
    var $this = $(evt);
    var $actionVal = 'minus-';
    plusMinusBindClick($this,$actionVal);
}

plusMinusBindClick = (e,actionVal) =>{
    var $bindId = e.attr('data-bindId');
    setTimeout(function(){
      $('.'+actionVal+$bindId)[0].click();
      console.log($('.'+actionVal+$bindId)[0],'bbb')
      setTimeout(function(){
        $.when($.getJSON('/cart.js', function(cart) {
          $count = cart.item_count;
          })).then(function(){
            var cartCount = $('.cart-link__count');
            cartCount.text($count);

            var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
            drawerItemCount.text($count);
          });
       },500);
    },500);
}


$('#_personalisetnc').on('change', function() {
    if ($(this).is(':checked')) {
      $('#_personalisetncerror').hide();
      $('.jsc-personalise-check-atc').css('border-color','#000'); 
    }
});

personaliseAddToCart = (e) => {
    if ($('#personalise-input').val() == "") {
        $('#_personaliseTxtError').show();

        if ($(window).width() < 480 ){
            $('html, body').animate({
                scrollTop: $('#_isPersonalisation').offset().top
            }, 500); 
        }
    } 
    else if (!$('#_personalisetnc').is(':checked')) { 
        $('#_personalisetncerror').show();
        $('#_personaliseTxtError').hide();
        $('.jsc-personalise-check-atc').css('border-color','#ff0000');
    }else{
        $('#_personalisetncerror').hide();
        $('#_personaliseTxtError').hide();
        $('.jsc-personalise-check-atc').css('border-color','#000'); 
        var $this = $(e);
        var $prod = {};
        var $prodCost_add = {};
        var $prodVid = parseInt($('.jsc--getMainId').val());
        var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
        var $qty = parseInt($('#personalise_quantity').val());
        var $prodTitle = $this.attr('data-prodTitle');
        var $prodCost_title = $this.attr('data-prodCostTitle');
        var jsonObj = [];

        var $inputText = $('#personalise-input').val();
        var $fontType = $('.jsc-font-type-list .font-selected').attr('font-family');
        var $enableSpecialChar = $('.jsc-font-type-list .font-selected').attr('data-special-char');
        var $threadColor = $('.jsc-threadcolor-list .tcolor-selected').attr('data-threadcolor');
        // var $posLayout = $('.jsc-position-list .layout-selected').attr('value');

        $prodCost_add['_Personalise'] = $prodTitle;
        $prodCost_add['_Personalisation'] = $inputText;
        $prodCost_add['_Font Type'] = $fontType;
        // $prodCost_add['_Position'] = $posLayout;
        $prodCost_add['_Thread Colour'] = $threadColor;

        $prod['_Main Product'] = $prodCost_title;
        $prod['Personalisation'] = $inputText;
        $prod['Font Type'] = $fontType;
        // $prod['Position'] = $posLayout;
        $prod['Thread Colour'] = $threadColor;

        $prodCost_add['_BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$inputText+'-'+$fontType+'-'+$enableSpecialChar+'-'+$threadColor;
        $prod['_BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$inputText+'-'+$fontType+'-'+$enableSpecialChar+'-'+$threadColor;

        var item = {};
        item ["id"] = $prodCost_vid;
        item ["quantity"] = $qty;
        item ["properties"] = $prodCost_add;
        jsonObj.push(item);
        var item = {};
        item ["id"] = $prodVid;
        item ["quantity"] = $qty;
        item ["properties"] = $prod;
        jsonObj.push(item);


        CartJS.addItems(jsonObj,
        {
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                console.log('success');
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                    bubbles: true
                }));

                $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.cart-link__count');
                    cartCount.text(cart.item_count);

                    var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                    drawerItemCount.text(cart.item_count);
                    onloadToggleDonation();
                    toggleUpsellBanner(cart);
                });

                if(window.location.href.includes('/cart')) {
                    location.reload();
                }
                else {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // open cart drawer
                }
                    
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            }
        });
    
    }

} 


changeFont = (e) => {
    $('.jsc-font-type-list').children('.font-option').removeClass('font-selected');
    $(e).addClass('font-selected');
    console.log('change font');
    var getText = $('#personalise-input').val();
    var enableSpecialCharacter = $(e).attr('data-special-char');

    if (enableSpecialCharacter == 'n'){
        $('.jsc-disabled-special-characters').show(); 
        // Construct regular expression pattern dynamically including icon texts
        var iconTexts = $('.jsc-font-icon-list .icon-text').map(function() {
            return $(this).attr('data-icon');
        }).get().join('');
        var regexPattern = '[^a-zA-Z0-9' + iconTexts + ']';
        getText = getText.replace(new RegExp(regexPattern, 'g'), '');
    } else {
        $('.jsc-disabled-special-characters').hide();  
    }

    var getFontFamily = $(e).attr('font-family').toString();
    var getFontSize = $(e).attr('font-size');
    var getMobFontSize = $(e).attr('mob-font-size');
    var getCharLimit = $(e).attr('data-character');

    $('#personalisation-text').css('font-size',getFontSize);
    $('#personalisation-text').css('font-size',getFontSize);
    $('#personalisation-text').css('font-family','"'+getFontFamily+'"');
    $('#personalisation-text').css('font-size',getFontSize);
   
    if ($(window).width() < 480 ){
        $('#personalisation-text').css('font-size',getMobFontSize); 
    }

    $('.personalise-char-limit-desc .limit').text(getCharLimit);
    $('#personalise-input').attr('maxlength',getCharLimit);
   
    // Truncate text if it exceeds the character limit
    if (getText.length > getCharLimit) {
        getText = getText.substring(0, getCharLimit);
    }

    constructTextOverlay(getText);

    $('#personalise-input').val(getText);
    $('.jsc-your-font .selected-fonttype').text(getFontFamily);
}

changeColor = (e) => {
    $('.jsc-threadcolor-list').children('.threadcolor-option').removeClass('tcolor-selected');
    $(e).addClass('tcolor-selected');

    var getColor = $(e).attr('data-threadcolor');
    var getColorCode = $(e).attr('data-threadcolorcode');

    $('#personalisation-text').css('color',getColorCode);
    $('.jsc-thread-color .selected-threadcolor').text(getColor);

    var getText = $('#personalise-input').val();
    constructTextOverlay(getText);
}

// changePosLayout = (e) => {
//     $('.jsc-position-list').children('.position-layout-option').removeClass('layout-selected');
//     $(e).addClass('layout-selected');

//     var _ltop = $(e).attr('data-ltop');
//     var _lleft = $(e).attr('data-lleft');
//     var _topTransform = $(e).attr('data-topTransform');
//     var _leftTransform =  $(e).attr('data-leftTransform');
  
//     $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
//     $(".personalisation-text-overlay").css( "top", _ltop);
//     $(".personalisation-text-overlay").css( "left", _lleft);

//     var getPosition = $(e).attr('value');
//     $('.jsc-text-position .selected-position').text(getPosition);
// }

addIconText = (e) => {
    var getIcon = $(e).attr('data-icon');
    
    // Check if adding the icon exceeds the maximum length
    var maxLength = parseInt($('#personalise-input').attr('maxlength'));
    if ($('#personalise-input').val().length + getIcon.length > maxLength) {
        return; // Exit function if exceeding max length
    }

    // Append the icon text to the input value
    $('#personalise-input').val(function(_, currentValue) {
        return currentValue + getIcon;
    });
    

    var getText = $('#personalise-input').val();
    constructTextOverlay(getText);

}

constructTextOverlay = (inputText) => {
  
    var iconTextEach = $('.jsc-font-icon-list .icon-text');

    iconTextEach.each(function(){
        var svgIcon = $(this).attr('data-icon');
        var svgCode = $(this).find('svg').prop('outerHTML');
        var regex = new RegExp(svgIcon, 'g');
  
        if (inputText.includes(svgIcon)) {
            // Replace hex icon with SVG code
            inputText = inputText.replace(regex, svgCode);
        }
    });
  
    // Update the text overlay
    $('#personalisation-text').html(inputText);

    var getThreadColor = $('.jsc-threadcolor-list .tcolor-selected').attr('data-threadcolorcode');
    $('#personalisation-text').css('color',getThreadColor);

    var getFontSize = $('.jsc-font-type-list .font-selected').attr('font-size');
    var getMobFontSize = $('.jsc-font-type-list .font-selected').attr('mob-font-size');
 
    $('#personalisation-text').find('svg').each(function() {
        if ($(window).width() < 480 ){
            $(this).css({
                'width': getMobFontSize,
                'height': getMobFontSize
            }); 
        }else{ 
            $(this).css({
                'width': getFontSize,
                'height':  getFontSize 
            });
        }
    });
    
    $('#personalisation-text').find('svg').each(function() {
        $(this).children().css({
            'fill': getThreadColor
        });
    });

}

toggleIconList= (e) => {
    $(".personalise-plus-icon").toggle(); 
    $(".personalise-minus-icon").toggle(); 
    $('.jsc-your-monogram-icon').toggle();
}

inputPersonaliseTxt = (e) => {
    $('#_personaliseTxtError').hide();
    var getText = $('#personalise-input').val();
    var getThreadColor = $('.jsc-threadcolor-list .tcolor-selected').attr('data-threadcolorcode');

    var selectedFont = $('.jsc-font-type-list').children('.font-option.font-selected');
    var enableSpecialCharacter = selectedFont.attr('data-special-char');

    if (enableSpecialCharacter == 'n'){
        $('.jsc-disabled-special-characters').show(); 
        // Construct regular expression pattern dynamically including icon texts
        var iconTexts = $('.jsc-font-icon-list .icon-text').map(function() {
            return $(this).attr('data-icon');
        }).get().join('');
        var regexPattern = '[^a-zA-Z0-9' + iconTexts + ']';
        getText = getText.replace(new RegExp(regexPattern, 'g'), '');
    } else {
        $('.jsc-disabled-special-characters').hide();  
    }

    constructTextOverlay(getText);

    $('#personalise-input').val(getText);
    $('#personalisation-text').css('color',getThreadColor);

    // click customise alt image
    $('.carousel.thumbnails .slider__item._altTxtCustomise img').click();
}

showPersonalise  = (e) => {
    $('#_isPersonalisation').show();
    $('.jsc-personalise-btn').hide();
    $('.main-prod-buy-buttons-row').hide();

    var selectedPosition = $('.jsc-position-list .position-layout-option').first();
    var getPosition = selectedPosition.attr('value');
    selectedPosition.addClass('layout-selected');

    var _ltop = selectedPosition.attr('data-ltop');
    var _lleft = selectedPosition.attr('data-lleft');
    var _topTransform = selectedPosition.attr('data-topTransform');
    var _leftTransform = selectedPosition.attr('data-leftTransform');
  
    $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
    $(".personalisation-text-overlay").css( "top", _ltop);
    $(".personalisation-text-overlay").css( "left", _lleft);

    var selectedFont = $('.jsc-font-type-list').children('.font-option.font-selected');
    var selectedThread = $('.jsc-threadcolor-list').children('.threadcolor-option.tcolor-selected');

    var getColor = selectedThread.attr('data-threadcolorcode');
    var getColorVal = selectedThread.attr('data-threadcolor');
    var getFontFamily = selectedFont.attr('font-family').toString();
    var getFontSize = selectedFont.attr('font-size');
    var getMobFontSize = selectedFont.attr('mob-font-size');
    var getCharLimit = selectedFont.attr('data-character');
    var enableSpecialCharacter = selectedFont.attr('data-special-char');

    $('.jsc-your-font .selected-fonttype').text(getFontFamily);
    $('.jsc-thread-color .selected-threadcolor').text(getColorVal);
    $('.jsc-text-position .selected-position').text(getPosition);

    $('#personalisation-text').css('font-size',getFontSize);
    $('#personalisation-text').css('font-family','"'+getFontFamily+'"');

    if ($(window).width() < 480 ){
        $('#personalisation-text').css('font-size',getMobFontSize); 
    }

    $('.personalise-char-limit-desc .limit').text(getCharLimit);
    $('#personalise-input').attr('maxlength',getCharLimit);
    $('#personalisation-text').css('color',getColor);

    if (enableSpecialCharacter == 'n'){
        $('.jsc-disabled-special-characters').show(); 
    }else{
        $('.jsc-disabled-special-characters').hide();  
    }

    // change overlay text position
    var _ltop = $(e).attr('data-ltop');
    var _lleft = $(e).attr('data-lleft');
    var _topTransform = $(e).attr('data-topTransform');
    var _leftTransform =  $(e).attr('data-leftTransform');
  
    $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
    $(".personalisation-text-overlay").css( "top", _ltop);
    $(".personalisation-text-overlay").css( "left", _lleft);

}
removePersonalise = () => {
    $('#_isPersonalisation').hide();
    $('.jsc-personalise-btn').show();
    $('.main-prod-buy-buttons-row').show();
    $('#personalisation-text').text('');
    $('.jsc-monogram-text-input-group.jsc-your-monogram-text input').val('');
}

dynamicHeightSideNav = () => {
    var stickyContainer = $('.jsc-side-nav__sticky-container');
    var sideNavSection = $('.jsc-side-nav-container');
   
    if ($(window).width() > 1299 && stickyContainer.length > 0 && sideNavSection.length > 0) {
        var sideNavSectionBottom = 0;
        var stickyContainerTop = stickyContainer.offset().top;

        sideNavSection.each(function(index, element) {
            var $currentElement = $(element);
            if (index === $('.jsc-side-nav-container').length - 1) { // Check if current element is the last one
                sideNavSectionBottom = $currentElement.offset().top + $currentElement.outerHeight();
            }
        });

        stickyContainer.css('height', (sideNavSectionBottom - stickyContainerTop) + 'px');
    }

}

// Start: FAQ page
toggleMobNavDropdown = (e) =>{

    var $target = $('#jsc-side-nav-index-parent-mobile');
    var isVisible = $target.css('display') === 'block';

    $target.css('display', isVisible ? 'none' : 'block');

    const $existingLoader = $('.jsc-bg-overlay');
    if (!isVisible) {
        // Show loader
        if ($existingLoader.length === 0) {
          const loaderHTML = `
            <div class="jsc-bg-overlay">
            </div>`;
          $('body').prepend(loaderHTML);
        }
      } else {
        $existingLoader.remove();
      }

}
closeMobFaqDropdown = () =>{
    var mob_dropdown = $('#jsc-side-nav-index-parent-mobile');
    if (mob_dropdown.length > 0){
        mob_dropdown.hide();
        $('.jsc-bg-overlay').remove();
    }
}
scrollToSection = (e, sectionId) =>{
    if($(window).width() < 1300){ 
        closeMobFaqDropdown();

        var faq_handle = $(e).attr('data-handle');
        $(".jsc-side-nav-index__heading span").each(function () {
            $(this).removeClass('active'); 

            if ($(this).attr('data-handle') == faq_handle) {  
                $(this).addClass('active'); 
            }
        });

        $("#jsc-side-nav-index-parent-mobile span").each(function () {
            $(this).removeClass('active'); 
            if ($(this).attr('data-handle') == faq_handle) {  
             $(this).addClass('active'); 
            }

        });

        var getBarHeight = $('announcement-bar').parent().length ? $('announcement-bar').parent().outerHeight() : 0;
                var getHeaderHeight = $('page-header').parent().length ? $('page-header').parent().outerHeight() : 0;
                var getFaqHeight = $('.jsc-side-nav__item-container').parent().length ? $('.jsc-side-nav__item-container').parent().outerHeight() : 0;
                var firstTabHeight = $('.collapsible-tabs:first .collapsible-tabs__heading').outerHeight() + 60;
                var offset = getBarHeight + getHeaderHeight + getFaqHeight + firstTabHeight;

         // Animate the scroll to the specific section ID
         $('html, body').scrollTop($('#faq-' + sectionId).offset().top - offset); 

    }else{
        $(e).closest('#jsc-side-nav-index-parent').find('.jsc-index-item').removeClass('active');
        $(e).addClass('active');
        var getBarHeight = $('announcement-bar').length ? $('announcement-bar').outerHeight() : 0;
        var getHeaderHeight = $('page-header').length ? $('page-header').outerHeight() : 0;
        var offset = getBarHeight + getHeaderHeight;

        // Animate the scroll to the specific section ID
        $('html, body').scrollTop($('#faq-' + sectionId).offset().top - offset);
    }
}
dynamicSideNavTop = () =>{
    var getBarHeight = $('announcement-bar').parent().length ? $('announcement-bar').parent().outerHeight() : 0;
    var getHeaderHeight = $('page-header').parent().length ? $('page-header').parent().outerHeight() : 0;
    var setHeight = getBarHeight + getHeaderHeight;
    var sideNavSection = $('.jsc-side-nav__item-container');

    if (sideNavSection.length > 0){ 
        $('html').css('scroll-behavior','smooth');
        $(window).trigger('scroll');
        // $('.jsc-side-nav__item-container').css('top', setHeight + 'px');
    }

    if($(window).width() < 1300){ 
        var mob_dropdown = $('.jsc-side-nav__item-container.jsc-faq-sticky').length ? $('.jsc-side-nav__item-container.jsc-faq-sticky').outerHeight(true) : 0;
        var curr_handle = $('.jsc-side-nav-index__heading span.active').attr('data-handle');
        $('#'+curr_handle).css('margin-top',mob_dropdown + 20);
    }
}
$(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    var sideNavSection = $('.jsc-side-nav__item-container');

    var getBarHeight = $('announcement-bar').parent().length ? $('announcement-bar').parent().outerHeight() : 0;
    var getHeaderHeight = $('page-header').parent().length ? $('page-header').parent().outerHeight() : 0;
    var totalHeight = getBarHeight + getHeaderHeight;

    if (sideNavSection.length > 0) {
        // Sticky position logic
        if (scrollTop < 1) {
            $('.jsc-side-nav__item-container').css('top', totalHeight + 'px');
        } else {
            $('.jsc-side-nav__item-container').css('top', getHeaderHeight + 'px');
        }

        // responsive highlighted category
        var tabs = $('.collapsible-tabs');
        tabs.each(function () {
            var offsetTop;
            var offsetBottom;
            scrollTop = scrollTop + 40;
            var tab = $(this);

            if ($(window).width() <= 768) {
                var mob_nav_title = $('.jsc-side-nav__item-container.jsc-faq-sticky');
                var stickyHeight = mob_nav_title.length ? mob_nav_title.outerHeight() : 0;
                offsetTop = tab.offset().top - getHeaderHeight - stickyHeight;
            } else {
                offsetTop = tab.offset().top - getHeaderHeight;
            }

            offsetBottom = offsetTop + tab.outerHeight();

            // If scroll position is within this section's range
            if (scrollTop >= offsetTop && scrollTop < offsetBottom) {
                var currentId = tab.find('.collapsible-tabs__heading').attr('id');

                $('.jsc-side-nav-index-parent .jsc-index-item').removeClass('active');
                $('.jsc-side-nav-index-parent ul li span[data-handle="' + currentId + '"]').addClass('active');

                $('.jsc-side-nav-index-parent-mobile .jsc-index-item').removeClass('active');
                $('.jsc-side-nav-index-parent-mobile ul li span[data-handle="' + currentId + '"]').addClass('active');

                $('.jsc-side-nav-index__heading span').removeClass('active');
                $('.jsc-side-nav-index__heading span[data-handle="' + currentId + '"]').addClass('active');
                return false; // Exit each loop once active tab found
            }
        });
    }
});


// End: FAQ page

onloadToggleDonation = () => {
    var donation_is_incart = false;
    var donation_prodId = parseInt($('.jsc-drawer-product-donation input').data('productid'));

    $.when($.getJSON('/cart.js', function(cart) {
        cartItems = cart.items;
    })).then(function(cart){
        if(cartItems.length == 0) {
            $('.jsc-drawer-product-donation').css('display', 'none');
        }
        else {
            $('.jsc-drawer-product-donation').css('display', 'flex');
            for (var d = 0; d < cartItems.length; d++) {
                var itemProdId = cartItems[d].product_id;

                if (itemProdId == donation_prodId) {
                    donation_is_incart = true;      
                }
            }

            if(donation_is_incart == true) {
                $('.jsc-drawer-product-donation input').prop('checked', true);
                $('.jsc-donation-variant-list').show();
            }
            else {
                $('.jsc-drawer-product-donation input').prop('checked', false);
                $('.jsc-donation-variant-list').hide();
            }
        }
    });
}

toggleVariantDonation = (d_prodId, d_vid) => {
    var changeDonation = true;
    $.when($.getJSON('/cart.js', function(cart) {
        cartItems = cart.items;
    })).then(function(cart){

        for (var d = 0; d < cartItems.length; d++) {
            var itemProdId = cartItems[d].product_id
            var itemId = cartItems[d].id;
            if (itemProdId == d_prodId) {
                if (itemId == d_vid) {
                    changeDonation = false;
                } else {
                    CartJS.updateItemById(itemId, 0);
                }
            }

          
        }

    if (changeDonation) {
        cartJsAtc(d_vid, 1, {'_Donation': 'Yes'}); 
    }

    });
}

toggleDonation = (e) => {
    var donation_first_vid = parseInt($(e).data('vid'));
    var donation_prodId = parseInt($(e).data('productid'));
    var addDonation = true;

    $.when($.getJSON('/cart.js', function(cart) {
        cartItems = cart.items;
    })).then(function(cart){
        for (var d = 0; d < cartItems.length; d++) {
            var productId = cartItems[d].product_id;;
            if (productId == donation_prodId) {
                var itemId = cartItems[d].id;
                addDonation = false;      
            }
        }

        if(addDonation == true) {
            cartJsAtc(donation_first_vid, 1, {'_Donation': 'Yes'});
        }
        else {
            cartJsUpdate(itemId, 0, {});
        }
    });

}

$(document).click(function(e) {
    if ($(window).width() < 480 ){
        if ($('.jsc-faq-index-parent').length > 0) {
            if (!$(e.target).closest('.jsc-overwrite-mobile-faq-index__heading').length) {
                $(".jsc-faq-index-parent").hide();
            }
        }
    }
});

mobileFaqToggle= () => {
    if ($(window).width() < 480 ){
        $('.jsc-faq-index-parent').toggle();
    }
}

jscFaqSelect = (e) => {
    if ($(window).width() < 480 ){
        var text_selected = $(e).text();
        $('.faq-index__heading').text(text_selected);
    }
}

initFeaturedCollectionSlider = () => {
    $('.section-featured-collection .collection-slider-row .jsc-slider .product-grid').flickity({
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        freeScroll: true,
        contain: true
    })
}

flickitySelectPrev = () => {
    var slider = $('.collection-slider-row .product-grid');
    slider.flickity('previous');
}

flickitySelectNext = () => {
    var slider = $('.collection-slider-row .product-grid');
    slider.flickity('next');
}

toggleAccordionMenu = (e) => {
    var accordionContent = $(e).siblings('.jsc-menu-accordion-content');
    var plusIcon = $(e).find('.jsc-icon-plus');
    var minusIcon = $(e).find('.jsc-icon-minus');

    accordionContent.toggleClass('active');
    if(accordionContent.hasClass('active')) {
        plusIcon.hide()
        minusIcon.show();
    }
    else {
        plusIcon.show();
        minusIcon.hide();
    }

    var targetMenuItem = $(e).parent();
    var otherMenuItem = targetMenuItem.siblings('.jsc-menu-accordion-item');
    otherMenuItem.each(function(index, item) {
        var content = $(item).find('.jsc-menu-accordion-content');
        var plus = $(item).find('.jsc-icon-plus');
        var minus = $(item).find('.jsc-icon-minus');
        if(content.hasClass('active')) {
            content.removeClass('active');
            plus.show();
            minus.hide();
        }
    });
}

customGridAtc = (e) => {
    var vid = parseInt($(e).data('vid'));
    cartJsAtc(vid, 1, {});
}

toggleHeaderMenu = (e) => {
    var menuContent = $(e).siblings('.jsc-nav-item-content');
    menuContent.toggleClass('active');

    // $(e).toggleClass('active');

    // close other open accordion
    // var targetNavItem = $(e).parent();
    // var otherNavItem = targetNavItem.siblings('.jsc-mobile-nav-item');
    // otherNavItem.each(function(index, item) {
    //     var content = $(item).find('.jsc-nav-item-content');
    //     if(content.hasClass('active')) {
    //         content.removeClass('active')
    //     }
    //     var navTitle = $(item).find('.jsc-nav-item-title');
    //     if(navTitle.hasClass('active')) {
    //         navTitle.removeClass('active');
    //     }
    // });
}

toggleBackNavChild = (e) => {
    var parentContent = $(e).closest('.jsc-nav-item-content');
    parentContent.toggleClass('active');
    console.log('parentContent: ', parentContent);
}

initMobileNavSlider = () => {
    var mobileNav =  $('#pageheader .logo-area.container .jsc-mobile-slider-nav');
    $('#pageheader .logo-area.container .jsc-mobile-slider-nav .jsc-nav-slider').flickity({
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        freeScroll: true,
        contain: true
    });
    mobileNav.css('visibility', 'visible');
}
triggerFilter = (e) => {
    $(e).toggleClass('active');
    if($(e).hasClass('active')) {
        var hideOos = $('.jsc-hide-oos');
        hideOos.click();
    }
    else {
        var showOos = $('.jsc-show-oos');
        showOos.click();
    }
}

checkUrlForFilter = () => {
    setInterval(() => {
        var url = window.location.href;
        var filterCheckbox = $('#jsc-availability-check');
        if(filterCheckbox.length) {
            if (url.includes("filter.v.availability=1")) {
                filterCheckbox.addClass('active');
            } else {
                filterCheckbox.removeClass('active');
            }
        }
    }, 1000);
}

togglePdpAccordion = (e) => {
    var $details = $(e).parent();
    var $productAccordion = $details.parents('.product-info-accordion');
    var $otherProdAccordion = $productAccordion.siblings('.product-info-accordion');

    $otherProdAccordion.each(function(index, item) {
        var $disclosure = $(item).find('.disclosure');
        if($disclosure.attr('open') === 'open') {
           $disclosure.removeAttr('open');
        }
    });
}

updateCharacterCount = (e) => {
    var characterCount = $(e).val().length;
    var $countText = $(e).parent().siblings('.jsc-cart-note-character').find('.jsc-note-character-count');
    $countText.text(characterCount);
}

onLoadUpdateCharacterCount = () => {
    var $cartNoteInput = $('cart-note textarea');
    var characterCount = $cartNoteInput.val().length;
    var $countText = $cartNoteInput.parent().siblings('.jsc-cart-note-character').find('.jsc-note-character-count');
    $countText.text(characterCount);
}


drawerUpsellGridHeight = () => {
    setInterval(() => {
        var $upsellGrid = $('.cart-item-upsells .product-grid--carousel')[0];
        var $productBlock = $($upsellGrid).find('.product-block');
        var maxHeight = 0;
        $productBlock.each(function(index, grid) {
            var $productTitle = $(grid).find('.product-block__title');
            var titleHeight = $productTitle.outerHeight(true);
            if (maxHeight < titleHeight) {
                maxHeight = titleHeight;
            }
        });
        $($productBlock).find('.product-block__title').css('height', maxHeight + 'px');
    }, 1000);
}

cartDrawerUpdate = () => {
    setTimeout(() => {
        jQuery.getJSON('/cart.js', function(cart) {
            var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
            drawerItemCount.text(cart.item_count);
            onloadToggleDonation();
            toggleUpsellBanner(cart);
        });
    }, 1000);
}

// start: cart upsell banner
toggleUpsellBanner = (cart) => {
    var upsellProdId = parseInt($('.jsc-product-upsell-banner').data('prod-id'));
    var cartItems = cart.items;
    var hideBanner = false;
    if(cartItems.length == 0)
    {
        hideBanner = true
    }
    else {
        $(cartItems).each(function(index, item) {
            var itemId = item.product_id;
            if(itemId === upsellProdId) { // upsell product already in the cart
                hideBanner = true;
            }
        });
    }

    if(hideBanner == true) {
        $('.jsc-product-upsell-banner').css('display', 'none');
    }
    else {
        $('.jsc-product-upsell-banner').css('display', 'flex');
        $('.jsc-product-upsell-banner').find('.jsc-upsell-variant-selector').css('display', 'none');
        $('.jsc-product-upsell-banner').find('.jsc-upsell-variant-selector > div').removeClass('active');
        $('.jsc-product-upsell-banner .jsc-upsell-product-info input').prop('checked', false);
    }
}

toggleUpsellVariantSelector = (e) => {
    var $variantSelector = $(e).parents('.jsc-upsell-product-info').find('.jsc-upsell-product-desc-container').find('.jsc-upsell-variant-selector');
    var isChecked = $(e).prop('checked');

    if(isChecked) {
        $variantSelector.css('display', 'flex');
    }
    else {
        $variantSelector.css('display', 'none');
    }
}

addSelectedEffect = (e) => {
    $(e).addClass('active');
    var $otherVariant = $(e).siblings();
    $otherVariant.removeClass('active');
}
// end: cart drawer upsell banner

openNewsletterPopup = () => {
    var $popupModal = $('pop-up.modal.popup-section');
    $popupModal.attr('open', '');
}

hideNewsletterTrigger = (e) => {
    sessionStorage.setItem('isHideTrigger', 'true');
    $(e).parent().hide();
}

onLoadCheckNewsletterTrigger = () => {
    var isHide = sessionStorage.getItem('isHideTrigger');
    if(isHide == 'true') {
        $('.jsc-newsletter-trigger').hide();
    }
}

cartJsAtc = (vid, qty, obj) => {
    CartJS.addItem(vid, qty, obj, {

        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                bubbles: true
            }));

            $(document).on('cart.requestComplete', function(event, cart) {
                var cartCount = $('.cart-link__count');
                cartCount.text(cart.item_count);

                var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                drawerItemCount.text(cart.item_count);
                onloadToggleDonation();
                toggleUpsellBanner(cart);
            });

            if(window.location.href.includes('/cart')) {
                location.reload();
            }
            else {
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // open cart drawer
            }
        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            $('#message').addClass('message-error');
            $('#message').html('There was a problem adding to the cart!');
        }
    });
}

cartJsUpdate = (vid, qty, obj) => {
    // Cart js add item, success callback, error callback
      CartJS.updateItemById(vid, qty, obj, {

        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                bubbles: true
            }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // open cart drawer

            $(document).on('cart.requestComplete', function(event, cart) {
                var cartCount = $('.cart-link__count');
                cartCount.text(cart.item_count);

                var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                drawerItemCount.text(cart.item_count);

                toggleUpsellBanner(cart);
            });

            if(window.location.href.includes('/cart')) {
                location.reload();
            }
        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            $('#message').addClass('message-error');
            $('#message').html('There was a problem adding to the cart!');
        }
    });  
}

// start: grid variant selector
showGridVariantSelector = (e) => {
    var $gridVariantSelector = $(e).siblings('.jsc-grid-variant-selector');
    
    // show variant selector and hide ATC button
    $gridVariantSelector.show();
    checkVariantAvailability(e);
    $(e).hide();

    // hide the variant selector and show ATC button again when cursor leave the selector
    $($gridVariantSelector).on('mouseleave', function() {
        $(this).hide();
        $(e).show();
    });
}
customVariantGridAtc = (e) => {
    var variantDataInput = $(e).parent().siblings("input[name='jsc-all-product-variants']");
    var variantsData = JSON.parse($(variantDataInput).val());
    var option1Name = $(e).data('option').toString();
    var vid = 0;
    for(var variant of variantsData) {
        if (variant.option1 === option1Name) {
            vid = parseInt(variant.id);
            break;
        }
    }
    cartJsAtc(vid, 1, {});
}
checkVariantAvailability = (e) => {
    var variantDataInput = $(e).siblings('.jsc-grid-variant-selector').find("input[name='jsc-all-product-variants']");
    var variantsData = JSON.parse($(variantDataInput).val());
    for(var variant of variantsData) {
        if (variant.available == false) {
            var option1Name = variant.option1;
            var liOption = variantDataInput.siblings('.jsc-variants').find('[data-option="' + option1Name + '"]');
            liOption.addClass('is-oos');
            liOption.removeAttr('onclick');
        }
    }
}
// end: grid variant selector

// mobile collection page promo grid height
setMobilePromoGridHeight = () => {
    if($(window).width() < 481) {
        var $productGrid = $('.product-grid');
        var $promoBanner = $($productGrid).find('.jsc-grid-promo-banner');
        if($promoBanner.length > 0) {
            $($promoBanner).each(function(index, banner) {
                var $nearestSibling = $(banner).nextAll('.product-block:first');
                var bannerHeight = $nearestSibling.height() - 30;
                $(banner).css('height', bannerHeight + 'px');
                console.log(bannerHeight);
            });
        }
    }
}

// start: close announcement bar
closeAnnouncementBar = (e) => {
    sessionStorage.setItem('isCloseAnnouncement', 'true');
    $(e).parents('.announcement-bar').hide();
    console.log('close');
}
onLoadCheckAnnouncementBar = () => {
    var isClose = sessionStorage.getItem('isCloseAnnouncement');
    if(isClose == 'true') {
        $('.announcement-bar').hide();
    }
}
// end: close announcement bar

initYmalSlider = () => {
    setTimeout(() => {
        var ymalGrid = $('.related-collection .product-grid');
        console.log(ymalGrid);
        if($(window).width() < 481) {
            $('.related-collection .product-grid').flickity({
                cellAlign: 'left',
                pageDots: false,
                prevNextButtons: false,
                adaptiveHeight: true,
                freeScroll: true,
                contain: true
            });
        }
    }, 1000);
}

mobileAccountOrderColSpan = () => {
    var $orderSummaryLabel = $('.order-table-container #order_details tfoot .order_summary .label');
    if($orderSummaryLabel.length > 0 && $(window).width() <= 480) {
        $orderSummaryLabel.attr('colspan', 2);
    }
}

// start: store selector
openStorePopup = (e) => {
    var $modal = $(e).siblings('.jsc-store-selector-modal');
    var $overlay = $('.overlay.js-overlay');

    $modal.addClass('active');
    $overlay.addClass('is-visible');
}

closeStorePopup = (e) => {
   var $modal = $(e).parents('.jsc-store-selector-modal');
   var $overlay = $('.overlay.js-overlay');

   $modal.removeClass('active');
   $overlay.removeClass('is-visible');
}

toggleSelector = (e) => {
    $(e).toggleClass('active');
}

updateStoreSelectorText = () => {
    var $modal = $('.jsc-store-selector-modal');
    var $selector = $($modal).find('.jsc-custom-selector');
    var $selectedText = $($selector).find('.jsc-custom-selector__selected-text');
    var $options = $($selector).find('.jsc-custom-selector__options li');
    var $submitBtn = $($modal).find('.jsc-store-selector-submit-btn');
    var currentUrl = window.location.href;

    $options.each(function() {
        $(this).on('click', function() {
            var optionText = $(this).text();
            var url = $(this).attr('data-url');

            $selectedText.text(optionText);
            if(currentUrl.startsWith(url)) {
                $submitBtn.attr('href', '#');
                $submitBtn.attr('target', '_self');
            }
            else {
                $submitBtn.attr('href', url);
            }
        });
    });
}
// end: store selector

// start: custom bundle
onclickBundleChgeVariant  = (evt,$variantTitle) => {
    var $this = $(evt);
    $this.parent().find('.opt-label').removeClass('active')
    $this.addClass('active');

    //Reset selected vid 
    var $findSelectedColor = $this.closest('.jsc-bundle-wrapper').find('.jsc-swatch-opt-list').find('.jsc-swatch-opt-wrapper').find('.jsc-swatch-opt.active');
    var $variantListHidden = $findSelectedColor.parent().find('.visually-hidden').find('._jsc-var');
    $variantListHidden.each(function() {
        var variantTitle = $(this).attr('variant-title');
        var variantId = $(this).attr('variant-id');
        
        if ($variantTitle == variantTitle) {
            $(this).closest('.jsc-swatch-opt-wrapper').find('.jsc-swatch-opt.active').attr('data-vid',variantId); 
        }
    });
}

onclickBundleChgeSwatch = (evt) => {
    var $this = $(evt);
    $this.parent().parent().find('.jsc-swatch-opt').removeClass('active')
    $this.addClass('active');

    //change featured image
    var $image = $this.attr('featured-image');
    $this.closest('.jsc-bundle-wrapper').find('.bundle-preview-img img').attr('src',$image);
    console.log($this.closest('.jsc-bundle-wrapper').find('.bundle-preview-img img'),'$image');

    var $title = $this.attr('product-title');
    $this.closest('.bundle-swatch-list').find('.bundle-preview-product-title').text($title);

    var $swatch = $this.attr('swatch');
    $this.closest('.bundle-swatch-list').find('.swatch').text($swatch);

    // Reset variant list - set first active option, available or oos 
    $this.closest('.bundle-swatch-list').find('.variant-picker').find('.jsc-opt-label-list').removeClass('active');
    $this.closest('.bundle-swatch-list').find('.variant-picker').find('.jsc-opt-label-list').removeClass('disabled');

    var $selected_vid = $this.parent('.jsc-swatch-opt-wrapper').find('.visually-hidden').find('.first-active-found').attr('variant-id');
    $this.attr('data-vid',$selected_vid);

    var $variantOptionList = $this.closest('.bundle-swatch-list').find('.variant-picker').find('.opt-label');
    $variantOptionList.each(function() {
        var $label = $(this);
        $label.removeAttr('disabled',true);
        var labelText = $.trim($label.find('span').text()); 

        var matchFound = false;
        var $variantListHidden = $this.closest('.bundle-swatch-list').find('.jsc-swatch-opt-list').find('.jsc-swatch-opt-wrapper').find('._jsc-var');
            $variantListHidden.each(function() {
                var variantTitle = $(this).attr('variant-title');
                
                if ($(this).hasClass('first-active-found') && labelText === variantTitle) {
                    $label.addClass('active'); 
                }

                if (labelText == variantTitle) {
                    matchFound = true; 
                    return false;
                }
            });
        
            if (!matchFound) {
                $label.addClass('disabled');
            }
    });

    // Reset url
    var $url = $this.attr('data-vurl');
    $this.closest('.jsc-bundle-wrapper').find('.bundle-preview-product-url').attr('href',$url);
}

bundleAtc = (e,title,fvid,bundleitem) => {
    var $this = $(e);
    var $jsonObj = [];
    var totalBundleItems = parseInt(bundleitem) + 1;

    var $cur_Date = new Date();
    var $date_time = $cur_Date.getDate() + "/"
                + ($cur_Date.getMonth()+1)  + "/"
                + $cur_Date.getFullYear() + ","
                + $cur_Date.getHours() + ":"
                + $cur_Date.getMinutes() + ":"
                + $cur_Date.getSeconds() + ":"
                + $cur_Date.getMilliseconds();
    var $bunldeId = fvid + '-' + $date_time; 

    //close bundle popup 
    if ($this.closest('.jsc-custom-bundle-modal').length) {
        $this.closest('.jsc-custom-bundle-modal').removeAttr('open');
      }

    var $swatchOptions =  $this.closest('.jsc-custom-bundle').find('.active.jsc-swatch-opt').toArray().reverse();

    $($swatchOptions).each(function() {
        var $bundleProd = {};
        var $bundleProp = {};   
        var $bundleVid = $(this).attr('data-vid');

        $bundleProd['id'] = $bundleVid;
        $bundleProd['quantity'] = 1;

        $bundleProp['_MainBundleIs'] = title;
        $bundleProp['_Bundle'] = true;
        // $bundleProp['_TotalBundleItems'] = totalBundleItems;
        // $bundleProp['_Off-Value'] = discount;
        // $bundleProp['_Quantity-Promo'] = 'percentage-off-bundle';
        $bundleProp['_BindID'] = $bunldeId;
        // $bundleProp['_DummyProduct'] = ftitle;
        // $bundleProp['_DummyProductUrl'] = furl;
        // $bundleProp['_DummyProductImg'] = fimage;

        $bundleProd['properties'] = $bundleProp;
        $jsonObj.push($bundleProd);
    });


    // Main Bundle product obj
    var $mainProd = {};
    var $mainProp = {};
    $mainProd['id'] = fvid;
    $mainProd['quantity'] = 1;
    $mainProp['_MainBundle'] = 'Yes';
    $mainProp['_BindID'] = $bunldeId;
    $mainProp['_TotalBundleItems'] = totalBundleItems;
    $mainProd['properties'] = $mainProp;
    $jsonObj.push($mainProd);

    CartJS.addItems($jsonObj,{
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                console.log('success');
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                    bubbles: true
                }));

                $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.cart-link__count');
                    cartCount.text(cart.item_count);

                    var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                    drawerItemCount.text(cart.item_count);
                    onloadToggleDonation();
                    toggleUpsellBanner(cart);
                });

                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); 
                    
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            }
    });

}

removeBundleSet = (keylist) => {
    var $keysplit = keylist.split(",");
    var $jsonObj = {};
    for (i=0;i<$keysplit.length;i++){
        $jsonObj[$keysplit[i]] = 0;
    }
  
    CartJS.updateItemQuantitiesById($jsonObj,{
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                $(document).on('cart.requestComplete', function(event, cart) {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                        bubbles: true
                    }));
                });       
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log("Error occur !", errorThrown);
            }
    });
};

removeIncompleteBundleSet = () => {
    $.getJSON('/cart.js', function(cart) {
        var _cartItems = cart.items;
        var $jsonObj = {};
        
        for (var i = 0; i < _cartItems.length; i++) {
          var _itemsKey = _cartItems[i].key;
          var _itemsBindID = _cartItems[i].properties['_BindID'];
      
          $('.jsc-bundle-item').each(function(){
            var $this = $(this);
            var $totalItem = $this.attr('data-total-item');
            var $thisSetBindID = $this.attr('data-bindid');
            var $eachItem = $this.find('.jsc-individual-bundle-item');
            var $countTotalItem_cartpage = 0;
        
            $eachItem.each(function(){
              $countTotalItem_cartpage += 1;
            });

            if ($totalItem != '') {
              if ($countTotalItem_cartpage + 1 != $totalItem) {          
                
                if (_itemsBindID == $thisSetBindID) {                
                  $jsonObj[_itemsKey] = 0;
            
                }
              }
            }
          });
          
        }

        if (Object.keys($jsonObj).length > 0) {
            $('#modal-pop_up_bundleoo').css('display','flex');
            CartJS.updateItemQuantitiesById($jsonObj);

        }
    }); 
}


closeBundleOOSPopup = () => {
    $('#modal-pop_up_bundleoo').hide();

    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
    }));

    $.getJSON('/cart.js', function(cart) {
        var cartCount = $('.cart-link__count');
        cartCount.text(cart.item_count);
    
        var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
        drawerItemCount.text(cart.item_count);
        
        onloadToggleDonation();
        toggleUpsellBanner(cart);
    });
};

// end: custom bundle
// start: mega menu max-width
setMegamenuWidth = () => {
    var width = $('.pageheader--layout-inline-menu-center .logo-area__left').width();
    console.log('proxy-nav width:', width);
    console.log('NavigationTier2-: ', $('.navigation__tier-2-container .container'))
    $('.navigation__tier-2-container .container').css('max-width', `${width}px`);
}
$(window).resize(function() {
    setMegamenuWidth();
})
// end: megamenu max-width